import React, { Component } from 'react';
import produce from 'immer';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import RejectReturnModal from '../../../../views/order/common/modal/RejectReturnModal';
import withModal from '../../../../lib/hoc/withModal';
import { orderActions } from '../../../../store/modules/order';
import { updateStoreWithPath } from '../../../../lib/common';

class RejectReturnModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  반품 거부 상세사유
       */
      reason: null,
      /**
       *  반품 거부 상세 이미지
       */
      rejectReturnAttachment: [],
    };
  }

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'rejectReturnModal',
    });
  };

  /**
   * 반품 거부 하기
   */
  onSubmit = () => {
    const { form, data, rejectOrderReturn } = this.props;
    const { orderItemId, orderItemReturnStatus } = data;
    const { reason, rejectReturnAttachment } = this.state;

    form.validateFields((err) => {
      if (err) return;

      rejectOrderReturn({
        orderItemId,
        reason,
        rejectReturnAttachment,
        orderItemReturnStatus,
      });

      this.closeModal();
    });
  };

  /**
   *  이미지 업로드
   */
  imgUpload = (data) => {
    this.setState(
      produce((draft) => {
        updateStoreWithPath(data.path, data.value, draft);
      }),
    );
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    const { isOpen, form, data } = this.props;

    return (
      <RejectReturnModal
        {...this.state}
        form={form}
        isOpen={isOpen}
        data={data}
        imgUpload={this.imgUpload}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.rejectReturnModal.isOpen,
    data: state.order.rejectReturnModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  rejectOrderReturn: orderActions.rejectOrderReturn,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(Form.create({})(RejectReturnModalContainer)));
